import { FilterType } from "../../types/filters";
import _ from "lodash";

export const getEvents = (data: GeoJSON.FeatureCollection) => {
  const filtered_data = { ...data };
  if (!filtered_data) {
    return filtered_data;
  }
  filtered_data.features = filtered_data.features.filter((datum) => {
    return parseInt(datum.properties.manual_upload) === 0;
  });

  return filtered_data;
};

export const getManualEvents = (data: GeoJSON.FeatureCollection) => {
  const filtered_data = { ...data };
  if (!filtered_data) {
    return filtered_data;
  }
  filtered_data.features = filtered_data.features.filter((datum) => {
    return parseInt(datum.properties.manual_upload) === 1;
  });

  return filtered_data;
};

// Apply filters to geojson data
export const applyFilters = (
  filters: FilterType,
  data: GeoJSON.FeatureCollection
) => {
  if (!data || data.features.length <= 0) {
    return data;
  }
  let filtered_data = { ...data };

  let filterMaterials = false;

  // if any checkbox is deselected, iterate through and filter
  filters.checkboxes.forEach((box) => {
    if (!box.value) {
      filterMaterials = true;
    }
  });

  if (filterMaterials) {
    // iterate through each item and compare to each material index.
    filtered_data.features = filtered_data.features.filter((datum) => {
      const props = datum.properties;
      let filter = false;
      for (const material of filters.checkboxes) {
        if (material.id === props.material_index) {
          filter = material.value;
        }
      }
      return filter;
    });
  }

  // filter by user data
  if (filters.user_data !== -1) {
    filtered_data.features = filtered_data.features.filter(
      (datum) => datum.properties.user_index === `${filters.user_data}`
    );
  }

  // filter manual data
  if (!filters.showManual) {
    filtered_data.features = filtered_data.features.filter(
      (datum) => datum.properties.manual_upload === "0"
    );
  }

  return filtered_data;
};

export const aggregateManualEvents = (data) => {
  let aggregated_features = _.groupBy(data, (datum) => {
    return datum.properties.log_index;
  });
  let events = [];
  Object.values(aggregated_features).forEach((items) => {
    let master_item = { ...items[0] };
    const spread_items = items.map((v) => {
      return v.properties;
    });
    master_item.properties = {
      items: spread_items,
      event_name: items[0].properties.event_name,
    };
    events.push(master_item);
  });
  return events;
};
